interface Props {
  children: React.ReactNode;
}

export function PageHeaderActions (props: Props) {
  return (
    <div className="flex items-center gap-2">
      {props.children}
    </div>
  );
}